module.exports = __webpack_public_path__ + "img/DE.80d275d1.svg";